import { Fetch } from '@polvo-labs/react-auth'
import React, { useState } from 'react'
import { useHistory } from 'react-router'
import { toast } from 'react-toastify'
import Button from '../../components/Button'
import Icon from '../../components/Icon'
import Loader from '../../components/Loader'
import Pagination from '../../components/Pagination'
import Private from '../../components/Private'
import Session from '../../components/Session'
import Text from '../../components/Text'
import routes from '../../config/routes'
import SessionType from '../../models/Session'
import { Container } from './styles'

interface Props {

}

const SessionScreen: React.FC<Props> = () => {
  const [apiUrl, setApiUrl] = useState(`${process.env.REACT_APP_API_URL}/sessions`)
  const [key, setKey] = useState(0)
  const history = useHistory()

  return (
    <Private>
      <Text
        tag="h1"
      >
        <Button
          label={(
            <Icon
              name="close"
            />
          )}
          smallPadding
          backgroundColor="transparent"
          onClick={() => history.push(routes.settings.security.index.path)}
        />
        {' '}Sessões ativas
      </Text>
      <Fetch
        key={key}
        url={apiUrl}
        loader={() => (
          <Loader
            darkMode
          />
        )}
      >
        {({ data }) => data && data.data && (
          <>
            <Container
              style={{ marginTop: '30px' }}
            >
              {data.data.map((session: SessionType) => (
                <Session
                  key={session.id}
                  session={session}
                  onLoggedOut={() => {
                    setKey(prev => prev + 1)
                    toast.success('Sessão removida com sucesso')
                  }}
                />
              ))}

              {data.meta && data.links && (
                <Pagination
                  meta={data.meta}
                  links={data.links}
                  onChange={setApiUrl}
                />
              )}
            </Container>
          </>
        )}
      </Fetch>
    </Private>
  )
}

export default SessionScreen
